import React from 'react'
import { Table } from 'antd'
import { ListComponent, BaseListComponentProps } from '../BaseComponent'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { Pagination } from 'components/Pagination'

type CreditsListProps = BaseListComponentProps & {
  loading: boolean,
  credits: any,
  pagination: any,
  editing?: any,
  defaultSubmitOptions: any,
  loadCredits: (args: SearchRequest) => void
}

export default class CreditsList extends ListComponent<CreditsListProps> {

  static defaultProps = {
    loading: false,
    credits: [],

    loadCredits: () => { }
  }
/*
  Columns:[]
Code
type_key
Shelter: json.model.organization.shelter.name
Currency: currency
total_amount
amount_used
amount_remaining
label*/

  tableColumns = [
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      responsive: ['md'] as any,
      render: (_: string, record: any) => record.code
    },
    {
      title: 'Type',
      dataIndex: 'type_key',
      key: 'type_key',
      responsive: ['md'] as any,
      render: (_: string, record: any) => record.type_key
    },
    {
      title: 'Shelter',
      dataIndex: ['shelter', 'json'],
      key: 'shelter',
      responsive: ['md'] as any,
      render: (_: string, record: any) => {
        console.log(record.json)
        if(!record?.json)return;
        const shelter = record.json.model.organization.shelter.name
        return shelter
      }
    },
    {
      title: 'Currency',
      dataIndex: 'currency',
      key: 'currency',
      responsive: ['md'] as any,
      render: (_: string, record: any) => record.currency
    },
    {
      title: 'Total Amount',
      dataIndex: 'total_amount',
      key: 'total_amount',
      responsive: ['md'] as any,
      render: (_: string, record: any) => record.total_amount
    },
    {
      title: 'Amount Used',
      dataIndex: 'amount_used',
      key: 'amount_used',
      responsive: ['md'] as any,
      render: (_: string, record: any) => record.amount_used
    },
    {
      title: 'Amount Remaining',
      dataIndex: 'amount_remaining',
      key: 'amount_remaining',
      responsive: ['md'] as any,
      render: (_: string, record: any) => record.amount_remaining
    },
    {
      title: 'Label',
      dataIndex: 'label',
      key: 'label',
      responsive: ['md'] as any,
      render: (_: string, record: any) => record.label
    }
  ]

  protected load() {
    this.searchOptions.search =  {
    }

    this.props.loadCredits(this.searchOptions)
  }


  render() {
    const { loading, pagination, credits, loadCredits, defaultSubmitOptions } = this.props

    return (
      <>
        <Table
          loading={loading}
          rowKey='uuid'
          columns={this.tableColumns}
          pagination={false}
          dataSource={credits}
          onChange={(pagination: any, filters: any, sorter: any) =>
            this.handleTableChange(pagination, sorter, (args) =>
              loadCredits({
                options: {
                   sort: args.options.sort.length > 0
                    ? args.options.sort
                    : defaultSubmitOptions.options.sort
                },
                search: { ...defaultSubmitOptions.search }
              }))}
        />
        <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={credits?.length}
          onChange={(pagination) =>
            this.handleTableChange(
              pagination,
              undefined,
              (args) => {
                console.log(args)
                loadCredits({
                  options: {
                    ...args.options, sort: args.options.sort.length > 0
                      ? args.options.sort
                      : defaultSubmitOptions.options.sort
                  },
                  search: { ...defaultSubmitOptions.search }
                })
              }
            )
          }
        />
      </>
    )
  }
}
